export default {"src":"/_next/static/media/flag-it.a28b8888.svg","height":2,"width":3,"blurWidth":0,"blurHeight":0};